<div class="content">
    <form #editForm="ngForm" data-qa="import-regel-form" [formGroup]="importRegelDetailForm">

        <header>
            <div>
            </div>

            <div class="buttons">

                <button matButton="outlined"
                        type="button"
                        data-qa="close-details-button"
                        (click)="westnetzSidenavService.closeRightnav()">
                    <mat-icon svgIcon="innogy_picto_close"></mat-icon>
                    Schließen
                </button>

                <button matButton="filled"
                        [disabled]="!importRegelDetailForm.valid"
                        type="button"
                        data-qa="submit-kontaktdaten-button"
                        (click)="saveImportRegel()">
                    <mat-icon>save</mat-icon>
                    Speichern
                </button>

            </div>
        </header>

        <div class="detail-main">
            <fieldset>
                <legend>Importregeln editieren</legend>
            </fieldset>

            <mat-form-field>
                <mat-label>Maximale Zuordnungsänderungen (global)</mat-label>
                <input matInput
                       formControlName="maxZuordnungsAenderungen"
                       id="maxZuordnungsAenderungen"
                       name="maxZuordnungsAenderungen"
                       type="number"
                >
            </mat-form-field>

            <mat-form-field>
                <mat-label>Netzverknüpfungsgrenzwert pro Stadtwerk</mat-label>
                <input matInput
                       formControlName="netzverknuepfungsgrenzwert"
                       id="netzverknuepfungsgrenzwert"
                       name="netzverknuepfungsgrenzwert"
                       type="number"
                >
            </mat-form-field>

            <mat-form-field>
                <mat-label>Grenzwert Änderungsleistung pro Stadtwerk (in MW)</mat-label>
                <input matInput
                       formControlName="limitAenderungLeistung"
                       id="limitAenderungLeistung"
                       name="limitAenderungLeistung"
                       type="number"
                >
            </mat-form-field>
        </div>
    </form>
</div>
